import { List } from 'immutable'

import { AVAILABLE_STEP_COMPONENTS } from 'routes/Signup/constants/AvailableStepComponents'
import type { SignupSteps } from 'routes/Signup/constants/SignupSteps'
import { signupConfig } from 'routes/Signup/signupConfig'

/**
 * Returns steps for signup. Steps without a component are filtered out.
 */
export const getSignupSteps = (): List<SignupSteps> => {
  const resultSteps: List<SignupSteps> = List(signupConfig.defaultSteps)

  /**
   * Filter out steps that do not have a component.
   */
  return resultSteps.filter(
    (step) => !!AVAILABLE_STEP_COMPONENTS[step as SignupSteps],
  ) as List<SignupSteps>
}
